import { FC, ReactNode, useContext, useEffect } from 'react';

import { CommonDrawerContext } from './CommonLayoutDrawer';

type TitleProps =
  | {
      children?: never;
      extra: ReactNode;
      onlyExtra: true;
    }
  | {
      children: ReactNode;
      extra?: ReactNode;
      onlyExtra?: never;
    };

export const CommonDrawerTitle: FC<TitleProps> = ({ children, extra, onlyExtra = false }) => {
  const { setTitle, setExtra } = useContext(CommonDrawerContext);

  useEffect(() => {
    if (!onlyExtra) {
      setTitle(children);
    }

    setExtra(extra);
  }, [children, extra, onlyExtra]);

  useEffect(() => {
    return () => {
      if (!onlyExtra) {
        setTitle(null);
      }
      setExtra(null);
    };
  }, []);

  return null;
};
